// extracted by mini-css-extract-plugin
module.exports = {"root":"EditProjectListingRequirementsPanel_root__TwNZZ","form":"EditProjectListingRequirementsPanel_form__RydT7","title":"EditProjectListingRequirementsPanel_title__s8tim"};